import { IUserProfile, wallet } from './base.interface';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpService } from '../core/services/http.service';


@Injectable()
export class BaseApiService {
  private _urlGetNotifications =
    environment.baseUrl + 'notification/notification-list/';
  private _urlProfile = environment.baseUrl + 'accounts/profile/';
  private _urlLogOut = environment.baseUrl + 'accounts/logout/';

  constructor(private _httpClient: HttpClient, private http: HttpService,) {}

  getNotifications(): Observable<any> {
    return this._httpClient.get<any>(this._urlGetNotifications, {
      params: {
        is_read: false,
      },
    });
  }

  getUserData(): Observable<IUserProfile> {
    return this._httpClient.get<IUserProfile>(this._urlProfile);
  }
  logout(body: ''): Observable<any> {
    return this._httpClient.post<any>(this._urlLogOut, body);
  }

  async walletInfo(){
		return await this.http.getSuccessResult<wallet>(
			{
				method:'GET',
				path:'payment/wallet/',
			},{inventory:0}
		)
  }
}
